import clsx from "clsx"
import { ProgramHeading } from "../general/ProgramHeading"

export const ProgramOutcomes = () => {
  const OUTCOMES = [
    {
      title: "3000+",
      description: "Alumni yang memilih harisenin.com",
    },
    {
      title: "99,98%",
      description: "Persentase alumni yang sudah bekerja",
    },
    {
      title: "Rp5-10 Juta",
      description: "Rentang gaji yang alumni dapatkan",
    },
    {
      title: "< 3 Bulan",
      description: "Rata-rata waktu alumni dapat pekerjaan setelah lulus",
    },
  ]

  return (
    <div className={clsx("relative sm:mb-15", "mb-8")} id="outcomes1">
      <ProgramHeading
        id="outcomes"
        title="Outcomes"
        subTitle="Seperti Apa Output yang Kami Berikan?"
      />
      <div className={clsx("flex sm:flex-row gap-4", "flex-col")}>
        {OUTCOMES.map((item, i) => (
          <div className={clsx("w-full")} key={i}>
            <h1 className={clsx("text-blue text-2xl")}>{item.title}</h1>
            <p className={clsx("text-sm text-black-48")}>{item.description}</p>
          </div>
        ))}
      </div>
      <p className={clsx("text-black-48 sm:mt-2", "mt-4")}>Update terakhir: Juni 2023</p>
    </div>
  )
}
